import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2f6cb492&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Users/afei/podcod_saas_project/shoppaas_member_front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6cb492",
  null
  
)

export default component.exports